import { ChakraProvider } from '@chakra-ui/react'
import { ConnectedRouter } from 'connected-react-router/immutable'
import { PubNubProvider } from 'pubnub-react'
import PubNub from 'pubnub'
import React from 'react'
import { QueryClientProvider } from 'react-query/react'
import { QueryClient } from 'react-query/core'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import './App.scss'
import Routes from './routes'
import store from './store'
import { history } from './store/history'
import theme from './theme'
import { uuid } from 'uuidv4'
import { AuthContextProvider } from './context/auth.context'
import { DeepStreamContextProvider } from './context/deepstream.context'
import { LanguageContextProvider } from './context/locale.context'
import { ReactQueryDevtools } from 'react-query/devtools'
import TagManager from 'react-gtm-module'
import { OrganizationContextProvider } from './context/organization.context'
import { DeepstreamClient } from '@deepstream/client'

const tagManagerArgs = {
	gtmId: process.env.REACT_APP_GTM_ID,
}

TagManager.initialize(tagManagerArgs)

const pubnub = new PubNub({
	publishKey: process.env.REACT_APP_PNB_PUBLISH_KEY,
	subscribeKey: process.env.REACT_APP_PNB_SUBSCRIBE_KEY,
	uuid: uuid(),
})

const client = new QueryClient({})

const ds = new DeepstreamClient(process.env.REACT_APP_DEEPSTREAM_URL)
ds.login()

function App() {
	return (
		<ChakraProvider theme={theme}>
			<QueryClientProvider client={client}>
				<BrowserRouter>
					<Provider store={store}>
						<AuthContextProvider>
							<OrganizationContextProvider>
								<DeepStreamContextProvider ds={ds}>
									<LanguageContextProvider>
										<PubNubProvider client={pubnub}>
											<ConnectedRouter history={history}>
												<Routes />
											</ConnectedRouter>
										</PubNubProvider>
									</LanguageContextProvider>
								</DeepStreamContextProvider>
							</OrganizationContextProvider>
						</AuthContextProvider>
					</Provider>
				</BrowserRouter>
			</QueryClientProvider>
		</ChakraProvider>
	)
}

export default App
